module.exports = __webpack_public_path__ + "images/instructor-tina-huang.webp";